import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { RiskLevelOption } from '@api/types';
import { RISK_LEVEL_LABEL_KEYS } from './labels';

const RISK_LEVEL_TOKENS = Object.keys(RISK_LEVEL_LABEL_KEYS) as (keyof typeof RISK_LEVEL_LABEL_KEYS)[];

export const useRiskLevelOptions = (): RiskLevelOption[] => {
  const { t } = useTranslation();
  return useMemo(
    () => RISK_LEVEL_TOKENS.map(token => ({ token, label: t(RISK_LEVEL_LABEL_KEYS[token]) })),
    [t],
  );
};
